import { Base } from 'layouts'
import { IndustryCertificateList } from 'components/IndustryCertificate'

import * as S from './styled'

export function IndustryCertificate() {
  return (
    <Base>
      <S.GridContainer container>
        <IndustryCertificateList />
      </S.GridContainer>
    </Base>
  )
}
